(() => {
  if (window.homeFeaturedOffersInitialized) return;
  window.homeFeaturedOffersInitialized = true;

  const initOffersCarousel = (section) => {
    if (!section || section.dataset.offersReady === 'true') return;

    const track = section.querySelector('[data-offers-track]');

    if (!track) return;

    const cards = Array.from(track.querySelectorAll('.home-featured-offers__card')).sort(
      (firstCard, secondCard) => Number(secondCard.dataset.offersDiscount) - Number(firstCard.dataset.offersDiscount)
    );

    if (cards.length) {
      const pageSize = 4;
      track.replaceChildren();

      for (let index = 0; index < cards.length; index += pageSize) {
        const page = document.createElement('div');
        page.className = 'home-featured-offers__page';
        page.setAttribute('role', 'list');
        page.dataset.offersPage = '';
        page.append(...cards.slice(index, index + pageSize));
        track.append(page);
      }
    }

    const pages = Array.from(track.querySelectorAll('[data-offers-page]'));
    if (pages.length < 2) return;

    section.dataset.offersReady = 'true';
    let currentPage = 0;
    let autoplayTimer;

    const update = () => {
      section.dataset.offersPage = String(currentPage);
      track.style.transform = `translateX(-${currentPage * 100}%)`;
    };

    const moveToPage = (page) => {
      currentPage = (page + pages.length) % pages.length;
      update();
    };

    const nextButton = section.querySelector('[data-offers-next]');

    const pauseAutoplay = () => {
      window.clearInterval(autoplayTimer);
      autoplayTimer = undefined;
    };

    const startAutoplay = () => {
      if (autoplayTimer || document.hidden) return;
      autoplayTimer = window.setInterval(() => moveToPage(currentPage + 1), 4000);
    };

    nextButton?.addEventListener('click', () => {
      pauseAutoplay();
      moveToPage(currentPage + 1);
      window.setTimeout(startAutoplay, 900);
    });

    const viewport = section.querySelector('[data-offers-viewport]');
    if (viewport) {
      let startX = 0;
      let startY = 0;
      let swiping = false;

      const handleSwipe = (endX, endY) => {
        const deltaX = endX - startX;
        const deltaY = endY - startY;
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.2) return;

        pauseAutoplay();
        moveToPage(currentPage + (deltaX < 0 ? 1 : -1));
        window.setTimeout(startAutoplay, 900);
      };

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
        startX = event.clientX;
        startY = event.clientY;
        swiping = true;
      });

      viewport.addEventListener('pointerup', (event) => {
        if (!swiping || (event.pointerType !== 'touch' && event.pointerType !== 'pen')) return;
        swiping = false;
        handleSwipe(event.clientX, event.clientY);
      });

      viewport.addEventListener('pointercancel', () => {
        swiping = false;
      });
    }

    section.addEventListener('pointerenter', pauseAutoplay);
    section.addEventListener('pointerleave', startAutoplay);
    section.addEventListener('focusin', pauseAutoplay);
    section.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', () => (document.hidden ? pauseAutoplay() : startAutoplay()));

    update();
    startAutoplay();
  };

  const initAllOffersCarousels = (root = document) => {
    root.querySelectorAll('[data-offers-carousel]').forEach((carousel) => {
      initOffersCarousel(carousel);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initAllOffersCarousels());
  document.addEventListener('shopify:section:load', (event) => initAllOffersCarousels(event.target));
})();
